var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-5 text-center"},[(_vm.rules)?_c('div',{staticClass:"text-left",domProps:{"innerHTML":_vm._s(_vm.rules)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }